import store from 'store'

export default class AbstractMapper {
  select (api, value, label, hasRemote) {
    return {
      api: api,
      value: value,
      label: label,
      hasRemote: hasRemote
    }
  }

  column (key, api, replace) {
    return {
      key: key,
      api: api,
      replace: replace
    }
  }

  replace (key) {
    const current = store.getters['session/getCurrent']
    const session = store.getters['session/getSession']
    switch (key) {
      case 'idazi':
        return current.company.id
      case 'ambito':
        return session.ambito
    }
  }
}
